import { makeBridgeRequest } from 'common'
import Data from 'common/api'

import { useMutation } from '@tanstack/react-query'

export type ReportType = 'DATA_ACCESS' | 'DATA_PROCESSING'

export interface GetReportResponse {
  url: string
  exist: boolean
  socialId: string
}

export interface PostReportRequest {
  trackNumber: string
  requestType: ReportType
  dataRequest: string
}

const PATH = '/central-privacy/v1'

const endpointSetter = (endpoint: string) => `${PATH}/${endpoint}`

export const base: Data = {
  action: 'requestAPI',
  evtId: '',
  metadata: {
    endpoint: '',
    headers: {
      'x-inter-lgpd-origem': 'US',
    },
    method: '',
    engine: 'CA',
  },
}

export const generateReportLink = (reportRequest: PostReportRequest): Data => ({
  ...base,
  metadata: {
    ...base.metadata,
    endpoint: endpointSetter('request-data/report-download'),
    method: 'POST',
    body: { ...reportRequest },
  },
})

export async function generateReportUS(reportRequest: PostReportRequest) {
  return makeBridgeRequest(generateReportLink(reportRequest)).then((response) => response)
}

export const useGenerateReportUS = (reportRequest: PostReportRequest) => {
  const {
    mutateAsync: fetchReport,
    data: report,
    isPending: isReportLoading,
    isError: isReportError,
  } = useMutation<GetReportResponse>({
    mutationFn: () => generateReportUS(reportRequest),
  })

  return { fetchReport, report, isReportLoading, isReportError }
}
